import {edgeServer} from '../api_client/apiClient';

const isTest = item =>{
	switch(item.session_type){
		case 'quiz': return true;
		case 'day3': return true;
		case 'day2': return item.study_type==='pattern';
		default:
		 return false;
	}
};

export function getQuizResult(weekId, courseId){
  return (dispatch) => {
    edgeServer.get(`console/courses/${courseId}/statistics?week=${weekId}&level=error`)
    .then((res)=>{
			let data = res.data.data.sessions.filter(item=>isTest(item));
      dispatch({
        type: "GET_QUIZ_RESULT_FULFILLED",
				payload: data
        // payload: res.data.data.sessions
      });
    });
  };
}

export function getPersonalTraining(courseId){
  return (dispatch) => {
    edgeServer.get(`console/courses/${courseId}/trainings`)
    .then((res)=>{
      dispatch({
        type: "GET_PT_FULFILLED",
        payload: res.data.data.trainings
      });
    });
  };
}

//materials argumnet looks like
// [{'data_type':'Dialogue','test_type':'Practice'},
//   {'data_type':'Pattern', 'test_type':'Quiz'}]
// session is just the number of session
export function getSession(sessionId){

	return (dispatch)=>{
		dispatch({
			type: "GET_SESSION_FULFILLED",
			payload: sessionId
		})
	}

	// return (dispatch) => {
  //   edgeServer.get(`console/datasets/sessions/${sessionId}`)
  //   .then((res)=>{
  //     dispatch({
  // 			type: "GET_PT_DETAUL_FULFILLED",
  // 			payload: {data: sortData(res.data.data_sets), id: sessionId}
  // 		});
  //   });
	// };
}

export function getQuizScore(courseId){
  return (dispatch) => {
    edgeServer.get(`console/courses/${courseId}/statistics/all`)
    .then((res)=>{
      dispatch({
        type: "GET_SCORE_FULFILLED",
        payload: res.data.data.scores
      });
    });
  };
}



// WEBPACK FOOTER //
// ./src/actions/ProAction.js